import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { rootRoute } from '../../../config';
import info from '../assets/info.png';
import time_elapse_icon from '../../../assets/time_elapse_icon.png';
import Button from '../../common/Button'
import PmModuleStyle from '../styles/pm.module.css';

const SimProgress = ({ popupState, actions }) => {
  const navigate = useNavigate();
  const [playSimulation, resumeSimulation, pauseSimulation, toggleSimulation, setToggleSimulation, isShowPlaceOrder,isEnabledSimulationBtn, setIsEnabledSimulationBtn] = actions;
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, simObj, setSimObj, getMonth, isLoader, setIsLoader, setError, error, isRequestLoading, pmPopup, setPmPopup] = popupState;
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const intervalDuration = 10; // 1 second in milliseconds
  const totalTime = 100; // Total time in seconds
  const isLeapYear = (year) => {
    return ((year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0)) ? 366 : 365;
  }
  let popupStyle = {
    padding: "5px 15px",
    backgroundColor: "white",
    zIndex: 2,
  }
  //simObj?.laststate?.deadLineMonths + simObj?.laststate?.currentRampValue
  const progressbar = { "valuemin": 0, "valuemax": 125, "valuenow": function () { return (Math.round(((this.valuemax - simObj?.laststate?.deadLineDays) / this.valuemax) * 100)) } }
  const showSummary = () => {
    setIsLoader(true);
    navigate(rootRoute + "/pm/summary");
  }
  const getShortMonth = (month) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
    return months[month - 1];
  }
  useEffect(() => { ((toggleSimulation) && simObj?.status != 'COMPLETED' && error == null && currentTime == totalTime) && resumeSimulation(); }, [currentTime])
  useEffect(() => { !isRequestLoading && setCurrentTime(0); }, [isRequestLoading])
  useEffect(() => {
    let intervalId;
    if (isPlaying && currentTime < totalTime) {
      intervalId = setInterval(() => {
        setCurrentTime((prevTime) => prevTime + 1);
      }, intervalDuration);
    } else {
      clearInterval(intervalId);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isPlaying, currentTime, totalTime]);

  useEffect(() => { (toggleSimulation) ? setIsPlaying(true) : setIsPlaying(false); }, [toggleSimulation]);
  useEffect(() => {
    if (document.getElementsByClassName(`${PmModuleStyle['simProg']}`)[0] != null && window.innerWidth > 991) {
      let top = 0;
      if (document.getElementsByClassName(`${PmModuleStyle['sim-progress-activity']}`)[0].getElementsByClassName(`${PmModuleStyle['posuccess']}`)[0] != null) {
        // top = document.querySelector(`.${PmModuleStyle._progress}`).clientHeight + document.querySelector(`.${PmModuleStyle.posuccess}`).clientHeight+12;
        top = 100;
        document.getElementsByClassName(`${PmModuleStyle["ui pointing label"]}`)[0].style.top = top + "%";
      }
      else {
        top = document.getElementsByClassName(`${PmModuleStyle['_progress']}`)[0].clientHeight + document.getElementsByClassName(`${PmModuleStyle['_progress']}`)[0].offsetTop;
        document.getElementsByClassName(`${PmModuleStyle["ui pointing label"]}`)[0].style.top = top + "px";
      }
    }
    if ((document.getElementsByClassName(`${PmModuleStyle['sim-progress-activity']}`)[0].getElementsByClassName(`${PmModuleStyle['posuccess']}`)[0]) != null && window.innerWidth < 991 && document.getElementsByClassName(`${PmModuleStyle['simProg']}`) != null) {
      document.getElementsByClassName(`${PmModuleStyle["ui pointing label"]}`)[0].style.left = "20%";
    }
  }, [simPrgPopup]);
  useEffect(() => {
    if ((simObj?.status == 'COMPLETED') && (document.getElementById("showSummary") != null)) {
      document.getElementById("showSummary").focus();
    }
  }, [simObj?.status])
  return (
    <div className={`${PmModuleStyle['sim-progress-activity']}`} id={"simProgressActivity"}>
      <div className={`${PmModuleStyle.pie}`} title={`${currentTime}% completed.`} style={{ '--p': (simObj?.status == 'COMPLETED') ? 100 : currentTime, '--b': '10px', '--c': 'purple' }} role='progressbar'></div>
      <div className={`${PmModuleStyle._progress} ${simPrgPopup ? `show ${PmModuleStyle.show}` : ''}`}>
        <div className={`${PmModuleStyle['time-progress']}`}>
          <div className={`${PmModuleStyle['remain-time']}`}>
            {/* <img className={(toggleSimulation && simObj.status != 'COMPLETED') ? `${PmModuleStyle.spin}` : ''} src={time_elapse_icon} alt="" /> */}
            <span style={{ "text-align": "center" }}><strong>{getShortMonth(simObj?.laststate?.statemonth)} {simObj?.laststate?.stateday}</strong>{`(${simObj?.laststate?.deadLineDays} days to deadline)`}</span>
            <span className="sr-only" role="status" aria-live="polite">
              {`${getShortMonth(simObj?.laststate?.statemonth)} ${simObj?.laststate?.stateday} (${simObj?.laststate?.deadLineDays} days to deadline)`}
            </span>
          </div>
          <div className={`ui progress indicating ${PmModuleStyle.progress} ${PmModuleStyle.ui}`}>
            <div className={`${PmModuleStyle['background']}`} id="time">
              <div role="progressbar"
                aria-valuenow={progressbar.valuenow()}
                aria-valuemin={progressbar.valuemin}
                aria-valuemax={progressbar.valuemax}
                aria-valuetext={`${progressbar.valuenow()}%`}
                className={` ${PmModuleStyle['progress-fg']} ${(toggleSimulation && simObj?.status != 'COMPLETED') ? `${PmModuleStyle.active}` : ''}`} style={{ "width": progressbar.valuenow() + '%' }}></div>
            </div>
          </div>
        </div>
        {
          (toggleSimulation && simObj?.status != 'COMPLETED') && <Button btnName="Pause Simulation" clickEventHandler={pauseSimulation} btnId="pauseSumButton" btnClass={`${(pmPopup?.pmSimBtn) ? `show ${PmModuleStyle['show']}` : ''}`}  btnParentStyle={pmPopup?.pmSimBtn ? popupStyle : {}}/>
        }{
          (!toggleSimulation && simObj?.status != 'COMPLETED') && <Button disabled={(simObj?.currentstep == 1 && !isEnabledSimulationBtn) ? true : false} btnName={simObj?.currentstep == 1 ? 'Start Simulation' : 'Resume Simulation'} clickEventHandler={playSimulation} btnId="playSumButton" btnClass={`${(pmPopup?.pmSimBtn) ? `show ${PmModuleStyle['show']}` : ''}`}  btnParentStyle={pmPopup?.pmSimBtn ? popupStyle : {}} />
        }{
          (simObj?.status == 'COMPLETED') && <Button btnName="Show Summary" clickEventHandler={showSummary} btnId="showSummary" btnParentStyle={pmPopup?.pmSimBtn ? popupStyle : {}} />
        }

      </div>
      <div className={`${PmModuleStyle['simmsg-container']}`}>
        {
          (simObj?.status == 'COMPLETED' || !isPlaying && simObj?.currentstep != 2) && <div className={`ui success message ${PmModuleStyle.ui} ${PmModuleStyle.success} ${PmModuleStyle.message} ${PmModuleStyle.simmsg}`}>
            <div role='alert'>
              {
                (simObj?.status == 'COMPLETED') && (<><img src={info} alt="info" /><p>{`Simulation is completed! Please click on "Show Summary" to view report.`}</p></>)
              }
              {/* {
                (<div className="sr-only"><p>{`Mean Absolute Precent Error: ${simObj?.laststate?.overAllMAPE ? simObj?.laststate?.overAllMAPE : 0} %`}</p></div>)
              } */}
              {/* {
                (<div className="sr-only"><p>{`Regular: ${simObj?.laststate?.fuelInformations?.REGULAR?.meanAbsolutePercentageError ? Math.floor(simObj?.laststate?.fuelInformations?.REGULAR?.meanAbsolutePercentageError) : 0}%; Midgrade:${simObj?.laststate?.fuelInformations?.MIDGRADE?.meanAbsolutePercentageError ? Math.floor(simObj?.laststate?.fuelInformations?.MIDGRADE?.meanAbsolutePercentageError) : 0}%; Premium: ${simObj?.laststate?.fuelInformations?.PREMIUM?.meanAbsolutePercentageError ? Math.floor(simObj?.laststate?.fuelInformations?.PREMIUM?.meanAbsolutePercentageError) : 0}%;`}</p></div>)
              } */}
              {
                (simObj?.status != 'COMPLETED' && !isPlaying && simObj?.currentstep > 1) && (<><img src={info} alt="info" /><p>{`Please select options for all tasks and ${simObj?.currentstep == 1 ? 'Start Simulation' : 'Resume Simulation'}`}</p></>)
              }
            </div>
          </div>
        }
        {
            (simObj?.status != 'COMPLETED' && simObj?.currentstep == 2) ? <div className={`ui success message ${PmModuleStyle.ui} ${PmModuleStyle.success} ${PmModuleStyle.message} ${PmModuleStyle.simmsg}`}>
                  <div role='alert'>
                    {
                      (<><img src={info} alt="info" /><p>{`Simulation is started.`}</p></>)
                    }
                  </div>
            </div> : ''
              
        }
      </div>
    </div>
  )
}

export default SimProgress